export default __webpack_public_path__ + "static/logo-gray-f6173711a1eb4f24984685158b1bd50b.svg";